import { priceCheck } from '@common/_assets/images';
import { FieldSet } from "@common/components/forms";
import { PageCard } from "@common/components/layout";
import { PriceCheckDiscountTable } from "@common/components/priceCheck/PriceCheckDiscountTable";
import { PriceCheckItemTable } from "@common/components/priceCheck/PriceCheckItemTable";
import { PriceCheckPackageTable } from "@common/components/priceCheck/PriceCheckPackageTable";
import { TabTitleWithPills } from "@common/components/tabs/TabsHelperComponents";
import QuerySearchButton from "@hospital/components/search/QuerySearchButton";
import { useHospitalApp } from "@hospital/hooks";
import { PriceCheckStore } from "@hospital/stores";
import React, { useCallback, useMemo, useState } from 'react';
import { Button, Modal, Tab, Tabs } from "react-bootstrap";
import { petcoGainsboro2 } from "../../common/_assets/color-constants";
export type usePriceCheckReturn = {
    priceCheckModal: JSX.Element;
    priceCheckButton: JSX.Element;
}
export const usePriceCheck = (): usePriceCheckReturn => {
    const [isShowing, setIsShowing] = useState(false);
    const hospital = useHospitalApp();
    const [priceCheckStore] = useState(new PriceCheckStore())
    React.useEffect(() => {
    }, [hospital, priceCheckStore]);


    const onShowPriceChecker = useCallback(() => {
        if (hospital?.currentHospital?.currentClinicId) {
            priceCheckStore.loadPriceChecker(hospital?.currentHospital?.currentClinicId);
        }
    }, [hospital.currentHospital?.currentClinicId, priceCheckStore]);


    const [activeTab, setActiveTab] = React.useState("salesitems");
    const searchResults = priceCheckStore.visitBuilderSearch.searchResults;
    const priceCheckModal = useMemo(() => {
        return (
            <Modal size="xl" centered show={isShowing} onHide={() => setIsShowing(false)} backdrop="static" onShow={onShowPriceChecker}>
                <Modal.Header closeButton>
                    <Modal.Title>Price Check</Modal.Title>
                </Modal.Header>
                <PageCard>
                    <div className="exam d-flex flex-column gap-4" style={{ backgroundColor: "white" }}>
                        <div style={{ width: "370px" }}>
                            <QuerySearchButton liveSearchDelay={250}
                                setQuery={priceCheckStore.visitBuilderSearch.setSearchQuery}
                                clearButtonText="Reset Search" placeholderText="Search sales items" />
                        </div>
                        <div style={{
                            paddingBottom: "1rem",
                            borderBottom: "1px solid " + petcoGainsboro2,
                            minWidth: 800
                        }}>
                            <FieldSet disabled={false}>
                                <Tabs activeKey={activeTab} onSelect={(key) => setActiveTab(key ?? "all")}>
                                    <Tab eventKey="salesitems" title={
                                        searchResults.searchQueryApplied ?
                                            <TabTitleWithPills title="Sales Items"
                                                color={searchResults.regularSalesItems.length == 0 ? "gray" : "green"}
                                                count={searchResults.regularSalesItems.length} />
                                            : <TabTitleWithPills title="Sales Items"
                                                color={priceCheckStore.totalRegularSalesItems == 0 ? "gray" : "green"}
                                                count={priceCheckStore.totalRegularSalesItems} />
                                    }>
                                        <PriceCheckItemTable items={searchResults.regularSalesItems} />
                                    </Tab>
                                    <Tab eventKey="packages" title={
                                        searchResults.searchQueryApplied ?
                                            <TabTitleWithPills title="Hospital Packages"
                                                color={searchResults.salesPackages.length == 0 ? "gray" : "green"}
                                                count={searchResults.salesPackages.length} />
                                            : <TabTitleWithPills title="Hospital Packages"
                                                color={priceCheckStore.totalSalesPackageCount == 0 ? "gray" : "green"}
                                                count={priceCheckStore.totalSalesPackageCount} />
                                    }>
                                        <PriceCheckPackageTable items={searchResults.salesPackages} />
                                    </Tab>
                                    <Tab eventKey="discounts" title={
                                        searchResults.searchQueryApplied ?
                                            <TabTitleWithPills title="Coupons/Discounts"
                                                color={searchResults.discountedSalesItems.length == 0 ? "gray" : "green"}
                                                count={searchResults.discountedSalesItems.length} />
                                            : <TabTitleWithPills title="Coupons/Discounts"
                                                color={priceCheckStore.totalDiscountSalesItems == 0 ? "gray" : "green"}
                                                count={priceCheckStore.totalDiscountSalesItems} />
                                    }>
                                        <PriceCheckDiscountTable items={searchResults.discountedSalesItems} />
                                    </Tab>
                                </Tabs>
                            </FieldSet>
                        </div>
                    </div>
                </PageCard>
            </Modal>
        )
    }, [
        onShowPriceChecker,
        activeTab,
        isShowing,
        priceCheckStore.totalDiscountSalesItems,
        priceCheckStore.totalRegularSalesItems,
        priceCheckStore.totalSalesPackageCount,
        priceCheckStore.visitBuilderSearch.setSearchQuery,
        searchResults.discountedSalesItems,
        searchResults.regularSalesItems,
        searchResults.salesPackages,
        searchResults.searchQueryApplied
    ])

    const priceCheckButton = useMemo(() => {
        return (
            <Button className="price-check" onClick={() => setIsShowing(true)}><img src={priceCheck}
                alt={"PC"} /></Button>
        )
    }, [])

    return useMemo(() => {
        return {
            priceCheckModal,
            priceCheckButton
        }
    }, [priceCheckButton, priceCheckModal])
};
